var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationMarkerGreenYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36.58 56.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#f3c715;stroke-width:2.83px;}.cls-1,.cls-2{stroke-miterlimit:10;}.cls-2{fill:#fff;stroke:#22bdc3;stroke-width:1.42px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 18.29,
    cy: 49.13,
    rx: 16.88,
    ry: 5.68
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18.16.71c-8,0-17.34,4.71-17.34,18,0,12.86,15.1,27.88,15.75,28.52a2.27,2.27,0,0,0,3.18,0c.64-.64,15.75-15.66,15.75-28.52C35.5,5.42,26.16.71,18.16.71Zm0,41.61C14.41,38.24,5.35,27.46,5.35,18.69c0-12.5,9.8-13.47,12.81-13.47S31,6.19,31,18.69C31,27.44,21.91,38.24,18.16,42.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18.16,9a8.92,8.92,0,1,0,9,8.92A8.94,8.94,0,0,0,18.16,9Zm0,14.45a5.53,5.53,0,1,1,5.56-5.53A5.55,5.55,0,0,1,18.16,23.43Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationMarkerGreenYellow);
export default __webpack_public_path__ + "static/media/location-marker_green_yellow.cabb5484ecf77f2e3a59c1875c354bd7.svg";
export { ForwardRef as ReactComponent };